import AxiosProvider, {useServerManager} from './ServerManagerProvider';

export default AxiosProvider;

export {
  useServerManager
}
